import { nullable2undefinable } from 'core/utils/commonUtils';
import { http } from 'core/utils/httpClient';
import { mapOrderShortInfo } from './orderService';
import type { CreateOrUpdateOrderActionRequest } from './dtoModels/order/createOrUpdateOrderActionRequest';
import type { OrderActionInfoResponse } from './dtoModels/order/orderActionInfoResponse';
import type { OrderActionInfo } from 'models/order/orderActionInfo';

export const mapOrderAction = (source: OrderActionInfoResponse): OrderActionInfo => ({
  ...source,
  dateCreate: new Date(source.dateCreate),
  dateAction: nullable2undefinable(source.dateAction, (d) => new Date(d)),
  user: nullable2undefinable(source.user),
  order: mapOrderShortInfo(source.order),
});

export const mapOrderActions = (source: OrderActionInfoResponse[]): OrderActionInfo[] =>
  source.map((a) => mapOrderAction(a));

export async function getOrderActionsAsync(orderId: number): Promise<OrderActionInfo[]> {
  const { data } = await http.get<OrderActionInfoResponse[]>(`orders/${orderId}/actions`);

  return mapOrderActions(data);
}

export async function createOrderActionAsync(
  orderId: number,
  request: CreateOrUpdateOrderActionRequest
): Promise<OrderActionInfo> {
  const { data } = await http.post<OrderActionInfoResponse>(
    `orders/${orderId}/actions`,
    request
  );
  return mapOrderAction(data);
}

export async function updateOrderActionAsync(
  orderId: number,
  actionId: number,
  request: CreateOrUpdateOrderActionRequest
): Promise<OrderActionInfo> {
  const { data } = await http.put<OrderActionInfoResponse>(
    `orders/${orderId}/actions/${actionId}`,
    request
  );
  return mapOrderAction(data);
}
